'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Online Digital Signatures SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Using Online Digital Signatures to Sign Documents',
            subtitle: 'Create a HelloSign account to start signing now.',
            buttonText: 'CREATE MY FREE ACCOUNT!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is an online digital signatures?'), _jsx('p', {}, void 0, 'A digital signature refers to a set of algorithms and encryption protections used to determine the authenticity of a document or software. An electronic signature is an online sign or symbol that indicates a singer’s intent to sign a document. HelloSign provides legally-binding, online electronic signatures for individuals and teams.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How can I use online signatures to sign documents?'), _jsx('p', {}, void 0, 'It’s easy to start signing documents using electronic signatures. By creating a HelloSign account, you’ll have access to tools that allow you to format your document, sign documents in your gmail account, and create reusable templates. Take a look at our pricing page to see the plan-by-plan breakdown of features offered.'), _jsx('h2', {
            className: headerClass
        }, void 0, ' What are some of the benefits of using online signatures?'), _jsx('p', {}, void 0, 'Besides making it simple to sign a document online, there are quite a few benefits to incorporating HelloSign into your workflow. Here are just a few:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Efficiency.'), '  Once you take your paperwork online, you’ll never waste time organizing paper documents or chasing down paper contracts in the office.  Users can sign documents entirely online with a few quick clicks.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Mobility.'), ' The HelloSign signer experience was designed to make it easy to sign contracts from anywhere, at anytime. Signers can easily access documents for signature using their tablet or mobile phone.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Security.'), ' HelloSign’s online signatures are protected by bank-level security measures. Features like audit trails and two-factor authentication ensure you always know what’s happening with your documents.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'How is HelloSign different from other free eSignature apps?'), _jsx('p', {}, void 0, 'Since day one, we’ve been focused on creating the very best signer experience in the eSignature industry. Every feature we’ve build and every update we’ve release has been guided by this dedication. We offer a clean and user-friendly design while providing top-notch security and support to our users.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Set up your online digital signatures today by activating a HelloSign account. It only takes a few clicks and you’re ready to start signing in minutes.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/online-digital-signatures.jsx
 ** module id = 820
 ** module chunks = 0
 **/